export const ADMIN = "ADMIN";
export const CREATE_BUDGET = "CREATE_BUDGET";
export const CREATE_PV = "CREATE_PV";
export const CREATE_MEMO = "CREATE_MEMO";
export const CASH_OFFICE = "CASH_OFFICE";
export const PAYROLL_OFFICER = "PAYROLL_OFFICER";
export const AUDIT = "AUDIT";
export const HEAD_OF_DEPARTMENT = "HEAD_OF_DEPARTMENT";
export const HEAD_OF_UNIT = "HEAD_OF_UNIT";
export const ADVANCE = "ADVANCE";
export const EXPENDITURE = "EXPENDITURE";
export const BURSAR = "BURSAR";
export const BUDGET_OFFICER = "BUDGET_OFFICE";
export const VC = "VC";
export const FINAL_ACCOUNT = "FINAL_ACCOUNT";
export const STAFF = "STAFF";

// Payroll access roles
export const PAYROLL_ACCESS_ROLES = [
  ADMIN,
  VC,
  PAYROLL_OFFICER,

  AUDIT,
  BURSAR
];

// Utility function to check if user has payroll access
export const hasPayrollAccess = (userRoles) => {
  if (!userRoles || !Array.isArray(userRoles)) return false;
  return PAYROLL_ACCESS_ROLES.some(role => userRoles.includes(role));
};

export const hasAccess = (userRoles, accessRoles) => {
    if(!userRoles || !Array.isArray(userRoles)) return false;
    return accessRoles.some(role => userRoles.includes(role));
}
